import { Toast } from 'react-bootstrap';

interface IProps {
  showToast: boolean;
  message: string;
  setShowToast: (value: boolean) => void;
}

const ToastWrapper = ({ showToast, message, setShowToast }: IProps) => {
  return (
    <Toast
      show={showToast}
      onClose={() => setShowToast(false)}
      className="align-items-center bg-dark border-0 bottom-0 end-0 light mb-3 me-3 position-fixed text-white z-index-5"
      delay={3000}
      autohide
    >
      <div className="d-flex">
        <Toast.Body className="P-3">
          <span className="fw-black">
            <code className="text-500">{message}</code>
          </span>
        </Toast.Body>
      </div>
    </Toast>
  );
};

export default ToastWrapper;
